import React, { useEffect, useMemo, useState } from "react";
import { Card, Col, Row, Stack } from "react-bootstrap";
import { MdAdminPanelSettings, MdClear } from "react-icons/md";
import { TextField } from "@mui/material";
import { MatDataGrid } from "../common/dataGrid/DataGrid";

function AdminListing({ agencyData }) {
  const [adminList, setAdminList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [sortingData, setSortingData] = useState({ field: "id", sort: "ASC" });

  // COMBINE PRIMARY agencyAdmin + agencyAdmins (UNIQUE BY ID)
  const allAdmins = useMemo(() => {
    const admins = [];
    const seenIds = new Set();

    const pushAdmin = (admin) => {
      if (!admin?.id || seenIds.has(admin.id)) return;
      seenIds.add(admin.id);
      admins.push(admin);
    };

    pushAdmin(agencyData?.agencyAdmin);
    (agencyData?.agencyAdmins || []).forEach(pushAdmin);

    return admins;
  }, [agencyData?.agencyAdmin, agencyData?.agencyAdmins]);

  const handleValueChange = (value) => {
    setSearchValue(value);
  };

  const handleClear = () => {
    setSearchValue("");
  };

  const columns = [
    {
      field: "id",
      headerName: "S. No.",
      editable: false,
      flex: 0.05,
      minWidth: 100,
      sortable: false,
    },
    {
      field: "firstName",
      headerName: "Admin Name",
      editable: false,
      sortable: true,
      flex: 0.6,
      minWidth: 150,
      renderCell: (params) => (
        <span>{`${params?.row?.firstName ?? ""} ${params?.row?.lastName && params?.row?.lastName !== null ? params?.row?.lastName : ""}`}</span>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      editable: false,
      flex: 0.6,
      minWidth: 220,
    },
    {
      field: "mobile",
      headerName: "Mobile No.",
      editable: false,
      flex: 0.6,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <span>{params?.row?.mobile ?? params?.row?.mobileNumber ?? ""}</span>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      editable: false,
      flex: 0.6,
      minWidth: 150,
    },
  ];

  useEffect(() => {
    let filtered = [...allAdmins];
    const search = searchValue?.trim()?.toLowerCase();

    if (search) {
      filtered = filtered.filter((admin) => {
        const fullName =
          `${admin?.firstName ?? ""} ${admin?.lastName ?? ""}`.toLowerCase();
        const email = (admin?.email ?? "").toLowerCase();
        const mobile = (
          admin?.mobile ??
          admin?.mobileNumber ??
          ""
        ).toLowerCase();
        const status = (admin?.status ?? "").toLowerCase();
        return (
          fullName.includes(search) ||
          email.includes(search) ||
          mobile.includes(search) ||
          status.includes(search)
        );
      });
    }

    if (sortingData?.field) {
      const field = sortingData.field;
      const isAsc = sortingData?.sort?.toUpperCase() === "ASC";
      filtered.sort((a, b) => {
        const aVal = (a?.[field] ?? "").toString().toLowerCase();
        const bVal = (b?.[field] ?? "").toString().toLowerCase();
        if (aVal < bVal) return isAsc ? -1 : 1;
        if (aVal > bVal) return isAsc ? 1 : -1;
        return 0;
      });
    }

    setAdminList(filtered);
  }, [allAdmins, searchValue, sortingData]);

  return (
    <Card className="bg-white shadow border-0 theme-card-cover mt-5 h-75">
      <div className="theme-card-header px-1 ">
        <Stack
          direction="horizontal"
          gap={2}
          className="flex-wrap justify-content-between px-3 pt-3 pb-2 align-items-start"
        >
          <h5 className="mb-0 position-relative fs-18 text-black fw-medium">
            <div className="align-items-center bg-primary d-inline-flex h-60 justify-content-center  position-absolute rounded start-0 text-white theme-icon-box w-60 z-1">
              <MdAdminPanelSettings size={40} />
            </div>
            Agency Admins
          </h5>
        </Stack>
      </div>
      <div className="flex-grow-1 d-flex flex-column px-3 h-100 overflow-auto">
        <div className="theme-data-table-filter px-1">
          <Row className="justify-content-end">
            <Col sm={5} lg={2} className="mb-3 pb-1">
              <TextField
                id="admin-search-filter"
                label="Search"
                variant="standard"
                fullWidth
                value={searchValue}
                onChange={(e) => {
                  handleValueChange(e.target.value);
                }}
              />
              <MdClear className="clear-postion" onClick={handleClear} />
            </Col>
          </Row>
        </div>
        <MatDataGrid
          controlId={"id"}
          columns={columns}
          data={adminList ?? []}
        />
      </div>
    </Card>
  );
}

export default AdminListing;
